import React from "react";

import { useTranslate } from "../translation/frontend";
import { useForm } from "./context";
import ArrowRightIcon from "./icons/ArrowRightIcon";

export function PaginationWide() {
  const translate = useTranslate();
  const { isLastPage, showValidationError, loading, disableNextButton, onBack, isSurvey } = useForm();

  // TODO: show an explanation if the buttons are disabled

  return (
    <section className="section report-paging">
      <div className="button-container">
        {isLastPage ? (
          <div>
            {showValidationError ? (
              <span className="report-paging__error continue is-invalid" role="alert">
                {translate("pageIncompleteError")}
              </span>
            ) : null}
            <button
              className="btn btn--continue btn--primary"
              type="submit"
              name="_action"
              value="next"
              disabled={loading || disableNextButton}
            >
              <span>{translate(isSurvey ? "sendSurveyLabel" : "sendReportLabel")}</span>
              <ArrowRightIcon />
            </button>
          </div>
        ) : (
          <div>
            {showValidationError ? (
              <span className="report-paging__error continue is-invalid" role="alert">
                {translate("pageIncompleteError")}
              </span>
            ) : null}
            <button
              className="btn btn--continue btn--primary"
              type="submit"
              name="_action"
              value="next"
              disabled={loading || disableNextButton}
            >
              <span>{translate("continueLabel")}</span>

              <ArrowRightIcon />
            </button>
          </div>
        )}
        {onBack ? (
          <button
            className="btn icon-button--left"
            name="_action"
            value="back"
            formNoValidate
            onClick={onBack}
            disabled={loading || disableNextButton}
          >
            <ArrowRightIcon />
            <span>{translate("backLabel")}</span>
          </button>
        ) : null}
      </div>
    </section>
  );
}
